var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rewards-progress"},[(_vm.steps.length)?_c('div',{staticClass:"rewards-levels"},_vm._l((_vm.steps),function(ref,i){
var label = ref.label;
var offset = ref.offset;
return _c('span',{key:i,style:({ left: (offset + "%") })},[_vm._v(_vm._s(label))])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"rewards-progress-bar"},[_c('div',{staticClass:"earned-progress-bar bg-primary-a8",style:({ width: (_vm.width + "%") })})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-890ca084","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rewards/Progress.vue
// module id = IFGp
// module chunks = 107